/**
 * Detects an aborted/superseded async operation (e.g. an Apollo `no-cache`
 * query cancelled because a newer request supersedes it, or an in-flight
 * request torn down on unmount). Apollo Client rejects these with an
 * `Error` whose message is "The operation was aborted.", while the DOM
 * `AbortController` path surfaces an `AbortError`.
 *
 * Used to tell benign cancellations apart from genuine failures (network,
 * auth, query errors) so the latter can still be surfaced/logged.
 */
export function isAbortError(error: unknown): boolean {
  return (
    error instanceof Error &&
    (error.name === 'AbortError' || error.message.includes('aborted'))
  );
}
